import axios from "@helpers/axios/private.axios";
import { USER, AUTH } from "../../constants";
import { getWallets, updateWalletEvent } from "@actions/wallet/changeWallet";

export const checkAuth = () => async (dispatch) => {
  if (!localStorage.getItem("authToken")) {
    dispatch({ type: AUTH.AUTH_LOGOUT });
    return Promise.resolve();
  }

  try {
    const response = await axios.get("/users/me");

    dispatch({
      type: USER.USER_RESPONSE,
      payload: { user: response.data.data },
    });

    dispatch({
      type: AUTH.AUTH_IS_AUTH,
      payload: true,
    });

    await dispatch(getWallets());
    dispatch(updateWalletEvent());

    return response.data.data;
  } catch (error) {
    console.error("Auth check failed:", error);

    // Only logout on 401 (unauthorized), not on 404 or other errors
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      dispatch({ type: AUTH.AUTH_LOGOUT });
    }

    // For other errors (like 404), just reject without logging out
    return Promise.reject(error);
  }
};
